/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserTaskResponse } from './GetUserTaskResponse';
import {
    GetUserTaskResponseFromJSON,
    GetUserTaskResponseFromJSONTyped,
    GetUserTaskResponseToJSON,
    GetUserTaskResponseToJSONTyped,
} from './GetUserTaskResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetUserTaskResponse
 */
export interface PaginatedResultOfGetUserTaskResponse {
    /**
     * 
     * @type {Array<GetUserTaskResponse>}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    items?: Array<GetUserTaskResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetUserTaskResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetUserTaskResponse interface.
 */
export function instanceOfPaginatedResultOfGetUserTaskResponse(value: object): value is PaginatedResultOfGetUserTaskResponse {
    return true;
}

export function PaginatedResultOfGetUserTaskResponseFromJSON(json: any): PaginatedResultOfGetUserTaskResponse {
    return PaginatedResultOfGetUserTaskResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetUserTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetUserTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetUserTaskResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetUserTaskResponseToJSON(json: any): PaginatedResultOfGetUserTaskResponse {
    return PaginatedResultOfGetUserTaskResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetUserTaskResponseToJSONTyped(value?: PaginatedResultOfGetUserTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetUserTaskResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

